module.exports = __webpack_public_path__ + "static/media/132.ebc24115.jpg";